import { createFileRoute } from '@tanstack/react-router';

import { PracticeCategoryList } from '@/features/Practice/PracticeCategoryList';

export const Route = createFileRoute('/_student/courses/$batchId/practice/$category/')({
  component: PracticeCategoryRoute,
});

function PracticeCategoryRoute() {
  const { batchId, category } = Route.useParams();
  return <PracticeCategoryList batchId={batchId} category={category} />;
}
